package pl.decks.personal.components.layouts.blog

import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.extendedByBase
import com.varabyte.kobweb.silk.style.vars.animation.TransitionDurationVars
import com.varabyte.kobweb.silk.theme.colors.palette.border
import com.varabyte.kobweb.silk.theme.colors.palette.color
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.vw
import pl.decks.personal.components.widgets.tag.TagStylesheet
import pl.decks.personal.extensions.toSitePalette
import pl.decks.personal.styles.FontTypography
import pl.decks.personal.styles.SiteLayout

object BlogPostStylesheet {
    object Vars {
        val separatorWidth by StyleVariable<CSSLengthNumericValue>(SiteLayout.Line.Normal)
        val imageOutlineWidth by StyleVariable<CSSLengthNumericValue>(SiteLayout.Line.Hairline)
        val accentColor by StyleVariable<Color>()
    }

    object Front {
        val Header = CssStyle.base {
            Modifier.maxWidth(SiteLayout.Breakpoint.lg)
        }

        val ImageContainer = CssStyle {
            val palette = colorMode.toPalette()
            base {
                Modifier
                    .fillMaxWidth()
                    .maxHeight(50.vw)
                    .overflow(Overflow.Hidden)
                    .borderRadius(bottomLeft = SiteLayout.Rounding.XLarge, bottomRight = SiteLayout.Rounding.XLarge)
                    .outline(Vars.imageOutlineWidth.value(), LineStyle.Solid, Vars.accentColor.value(palette.border))
                    .transition {
                        property("all")
                        duration(TransitionDurationVars.Normal.value())
                        timingFunction(TransitionTimingFunction.EaseInOut)
                    }
            }

            Breakpoint.LG {
                Modifier.maxHeight(50.vh)
            }
        }
        val Image = CssStyle.base {
            Modifier.objectFit(ObjectFit.Cover)
        }
        val Details = CssStyle.base {
            Modifier
                .fillMaxWidth()
                .padding(topBottom = SiteLayout.Space.XLarge, leftRight = SiteLayout.Space.XXLarge)
                .gap(SiteLayout.Space.XSmall)
        }
        val Authorship = CssStyle.base {
            Modifier.fillMaxWidth().color(Vars.accentColor.value(colorMode.toPalette().color))
        }
        val Title = FontTypography.sansSerif.extendedByBase {
            Modifier
                .fontSize(FontTypography.Size.XLarge)
                .lineHeight(FontTypography.LineHeight.XSmall)
                .fontWeight(FontTypography.Weight.Bold)
                .color(Vars.accentColor.value(colorMode.toPalette().color))
        }
        val Divider = CssStyle.base {
            val palette = colorMode.toPalette()
            Modifier.borderTop(Vars.separatorWidth.value(), LineStyle.Solid, Vars.accentColor.value(palette.border))
        }
    }

    val Layout = CssStyle.base {
        val accents = colorMode.toSitePalette().accents
        Modifier
            .fillMaxWidth()
            .setVariable(Vars.accentColor, accents.primary)
            .setVariable(TagStylesheet.Vars.textColor, accents.secondary)
    }
    val Markdown = CssStyle {
        cssRule("p") {
            Modifier.margin(topBottom = SiteLayout.Space.XXSmall)
        }
    }
}
